<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :moduleName="moduleName"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
    ></CommonFrame>
    <lk-form :label-width='120' label-position="right">
       <lk-card title='促销活动基础信息' class="cardContainer">
        <lk-row :gutter='16'>
          <lk-col span='8'>
            <lk-form-item  label='活动类型:'>
              <span>{{promoteSales.promoteTypeName}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='8'>
            <lk-form-item label='活动门店:'>
              <span>{{promoteSales.storeName}}</span>
            </lk-form-item>
          </lk-col>
            <lk-col span='8'>
            <lk-form-item  label='活动范围:'>
              <span>{{promoteSales.activityTypeName}}</span>
            </lk-form-item>
          </lk-col>

        </lk-row>
        <lk-row :gutter='16'>
          <lk-col span='8'>
            <lk-form-item  label='活动名称:'>
              <span>{{promoteSales.name}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='8'>
            <lk-form-item label='统计类型:'>
              <span>{{statisticalTypeName}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='8'>
            <lk-form-item  label='起止时间:'>
              <span>{{promoteSales.timeBegin}} - {{promoteSales.timeEnd}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
           <lk-col span='8'>
            <lk-form-item label='管理类型:'>
              <span>{{managementTypeName}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-card>
       <lk-card  title="活动详情">
        <div>
          <!-- 条件商品 -->
          <AddPromotionGoods
            v-model="goodsFormalList"
            :able='false'
          ></AddPromotionGoods>
          <!-- 条件商品结束 -->
          <!-- 促销商品 -->
            <AddPromotionGoods
              v-model="goodsGiveList"
              :isPromotion='true'
              :able='false'
              :isShow='isShow'
            ></AddPromotionGoods>
          <!-- 促销商品结束 -->
          <ActiveRules
            v-model="ruleResultList"
            :goodsFormalList='goodsFormalList'
            :promoteType='promoteSales.promoteType'
            :goodsGiveList='goodsGiveList'
            :rebateNote='promoteSales.rebateNote'
            :able='false'
          ></ActiveRules>
        </div>
      </lk-card>
    </lk-form>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';
import AddPromotionGoods from '../../../components/marketing/addPromotionGoods.vue';
import ActiveRules from '../../../components/marketing/activeRules.vue';
import sharedDara from '../../../libs/sharedDara';

export default {
  name: 'PromoteSales',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
    AddPromotionGoods,
    ActiveRules,
  },
  computed: {
    statisticalTypeName() {
      return this.promoteSales.statisticalType ? this.statisticalTypes[this.promoteSales.statisticalType - 1].title : null;
    },
    managementTypeName() {
      return this.promoteSales.managementType
        ? sharedDara.managementTypeList.find(item => item.managementType === this.promoteSales.managementType).name
        : '';
    },
    isShow() {
      return this.promoteSales.promoteType == 1;
    },
  },
  data() {
    return {
      statisticalTypes: [
        {
          title: '票折结算',
          id: 1,
        },
        {
          title: '自负成本',
          id: 2,
        },
      ],
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '促销活动审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      columns: [
        {
          title: '行号',
          width: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        { title: '商品编码', key: 'drugSerialCode' },
        { title: '药品通用名', key: 'approvedDrugNames' },
        { title: '规格', key: 'specifications' },
        { title: '包装单位', key: 'drugMiniPackageUnit' },
        { title: '生产厂家', key: 'manufacturer' },
        { title: '商品类型', key: 'goodsTypeName' },
        { title: '剂型', key: 'dosageForm' },
      ],
      promoteSales: {},
      goodsFormalList: [],
      goodsGiveList: [],
      ruleResultList: [],
    };
  },
  methods: {
    getBreakageInfo(businessUrl) {
      axios.post(businessUrl).then((res) => {
        if (res.data.status === 200) {
          this.promoteSales = res.data.data.promoteSales;
          this.promoteSales.timeBegin = utils.formatDate(res.data.data.promoteSales.timeBegin, 'YYYY/MM/DD HH:mm:ss');
          this.promoteSales.timeEnd = utils.formatDate(res.data.data.promoteSales.timeEnd, 'YYYY/MM/DD HH:mm:ss');
          this.ruleResultList = res.data.data.promoteRuleList;
          let goodsGiveList = [];
          let goodsFormalList = [];
          let salesGoodsList =  res.data.data.salesGoodsList;
          salesGoodsList.forEach(item => {
            item.dosageForm = item.dosageFormName;
            item.drugSerialCode = item.serialCode;
            item.drugMiniPackageUnit = item.minPkgUnitName;
            item.batchSeqList = item.batchSeq.split(",");
            item.batchSeq == '' ? item.inventoryNum = 0 : null;
            item.isPromote ? goodsGiveList.push(item) : goodsFormalList.push(item);
          })
          this.goodsGiveList = goodsGiveList;
          this.goodsFormalList = goodsFormalList;
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getBreakageInfo(this.approvalParams.businessUrl);
  },
};
</script>
<style lang="less" >
  .cardContainer {
    margin-top: 20px;
  }
  .steps-wrap{
    padding-top: 30px;
    padding: 30px;
  }
  .card-title {
    margin: 10px 0;
  }
  .card-margin {
    margin-top: 10px;
    .active-rules {
      display: flex;
      flex-direction: column;
      .rules-content {
        display: flex;
        margin-bottom: 20px;
        .rebateNote {
          padding-top: 12px;
        }
      }
    }
    .rules-left {
      width: 80px;
      padding-top: 12px;
    }
  }
  .rules-right {
    display: flex;
    flex-direction: column;
    .rules-right-contantCheck {
      padding: 12px 4px !important;
    }
    .rules-right-contant {
      display: flex;
      align-items: center;
      padding: 4px;
      .rules-item {
        display: flex;
        align-items: center;
        .num-sapn {
          width: auto;
          margin: 0 6px;
        }
        .rules-span {
          width: auto;
          margin: 0 6px;
        }
        .active-span {
          width: auto;
          margin: 0 6px;
        }
      }
      .maxNumContent {
        display: flex;
        align-items: center;
      }
      .deleteOne {
        width: 40px;
        margin-left: 8px;
      }
    }
    .addOne {
      width: 40px;
    }
    .addCon {
      margin-top: 4px;
      color: #2d8cf0;
    }
  }
</style>
